(function () {
    'use strict';

    angular
        .module('jotApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('tab-objects', {
                parent: 'entity',
                url: '/tab-objects?page&sort&search',
                data: {
                    authorities: ['ROLE_DOMAIN_USER'],
                    pageTitle: 'jotApp.tabObjects.home.title'
                },
                views: {
                    'content@main': {
                        templateUrl: 'app/entities/tab-objects/tab-objects.html',
                        controller: 'TabObjectsController',
                        controllerAs: 'vm'
                    }
                },
                onEnter: ['TabObjectsRedeployablesCounter', function (TabObjectsRedeployablesCounter) {
                    TabObjectsRedeployablesCounter.start();
                }],
                onExit: ['TabObjectsRedeployablesCounter', function (TabObjectsRedeployablesCounter) {
                    TabObjectsRedeployablesCounter.stop();
                }],
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {

                        squash: true
                    },
                    search: {
                        value: '',
                        squash: true
                    },
                    fleet: {
                        value: '-1'
                    },
                    objectType: {
                        value: '-1'
                    },
                    objectState: {
                        value: '-1'
                    },
                    toUpdate: {
                        value: '-1'
                    },
                    online: {
                        value: '-1'
                    },
                    tracked: {
                        value: '-1'
                    },
                    itemsPerPageChosen: null,
                    predicates : {}

                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicates : $stateParams.predicates,
                            search: $stateParams.search,
                            fleet: $stateParams.fleet,
                            objectType: $stateParams.objectType,
                            objectState: $stateParams.objectState,
                            toUpdate: $stateParams.toUpdate,
                            online: $stateParams.online,
                            tracked: $stateParams.tracked
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('tabObjects');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('tab-objects-detail', {
                parent: 'tab-objects',
                url: '/tab-objects/{id}',
                data: {
                    authorities: ['ROLE_DOMAIN_USER'],
                    pageTitle: 'jotApp.tabObjects.detail.title'
                },
                views: {
                    'content@main': {
                        templateUrl: 'app/entities/tab-objects/tab-objects-detail.html',
                        controller: 'TabObjectsDetailController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('tabObjects');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'TabObjects', function ($stateParams, TabObjects) {
                        return TabObjects.get({id: $stateParams.id});
                    }]
                }
            })
            .state('tab-objects-new', {
                parent: 'tab-objects',
                url: '/new',
                data: {
                    authorities: ['ROLE_DOMAIN_USER'],
                    pageTitle: 'jotApp.tabObjects.detail.title'
                },
                views: {
                    'content@main': {
                        templateUrl: 'app/entities/tab-objects/tab-objects-dialog.html',
                        controller: 'TabObjectsDialogController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('tabObjects');
                        return $translate.refresh();
                    }],
                    entity: function () {
                        return {
                            objectUniqueCode: null,
                            objectCaCrt: null,
                            objectClientCrt: null,
                            objectClientKey: null,
                            objectName: null,
                            objectDescription: null,
                            objectNotes: null,
                            objectLongitude: null,
                            objectLatitude: null,
                            id: null
                        };
                    }
                }
            })
            .state('tab-objects-edit', {
                parent: 'tab-objects',
                url: '/{id}/edit',
                data: {
                    authorities: ['ROLE_DOMAIN_USER'],
                    pageTitle: 'jotApp.tabObjects.detail.title'
                },
                views: {
                    'content@main': {
                        templateUrl: 'app/entities/tab-objects/tab-objects-dialog.html',
                        controller: 'TabObjectsDialogController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('tabObjects');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'TabObjects', function ($stateParams, TabObjects) {
                        return TabObjects.get({id: $stateParams.id});
                    }]
                }
            })
            .state('tab-objects.delete', {
                parent: 'tab-objects',
                url: '/{id}/delete',
                data: {
                    authorities: ['ROLE_DOMAIN_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/tab-objects/tab-objects-delete-dialog.html',
                        controller: 'TabObjectsDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['TabObjects', function (TabObjects) {
                                return TabObjects.get({id: $stateParams.id});
                            }]
                        }
                    }).result.then(function () {
                        $state.go('tab-objects', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('tab-objects.register', {
                parent: 'tab-objects',
                url: '/register',
                data: {
                    authorities: ['ROLE_DOMAIN_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/tab-objects/tab-objects-register-dialog.html',
                        controller: 'TabObjectsRegisterController',
                        controllerAs: 'vm',
                        size: 'md',
                    }).result.then(function () {
                        $state.go('tab-objects', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('tab-objects.redeployment', {
                parent: 'tab-objects',
                url: '/redeploy/{id}',
                data: {
                    authorities: ['ROLE_DOMAIN_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', 'TabObjectsRedeployablesCounter', function ($stateParams, $state, $uibModal, TabObjectsRedeployablesCounter) {
                    $uibModal.open({
                        templateUrl: 'app/entities/tab-objects/tab-objects-redeploy-dialog.html',
                        controller: 'TabObjectsRedeploymentController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entityId: function () {
                                return $stateParams.id;
                            }
                        }
                    }).result.then(function () {
                        $state.go('tab-objects', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }],
                params: {
                    id: {
                        value: null,
                        squash: true
                    }
                }
            })
            .state('tab-objects.provision', {
                parent: 'tab-objects',
                url: '/provision/{id}',
                data: {
                    authorities: ['ROLE_DOMAIN_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/tab-objects/tab-objects-provision-dialog.html',
                        controller: 'TabObjectsProvisionController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entityId: function () {
                                return $stateParams.id;
                            }
                        }
                    }).result.then(function () {
                        $state.go('tab-objects', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }],
                params: {
                    id: {
                        value: null,
                        squash: true
                    }
                }
            })
            .state('tab-objects.maintenance', {
                parent: 'tab-objects',
                url: '/{id}/maint',
                data: {
                    authorities: ['ROLE_DOMAIN_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/tab-objects/tab-objects-maint-dialog.html',
                        controller: 'TabObjectsMaintenanceController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['TabObjects', function (TabObjects) {
                                return TabObjects.get({id: $stateParams.id});
                            }]
                        }
                    }).result.then(function () {
                        $state.go('tab-objects', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('tab-objects-properties', {
                parent: 'entity',
                url: '/{id}/tab-object-properties/',
                data: {
                    authorities: ['ROLE_TECH'],
                    pageTitle: 'jotApp.tabDevicesReleasesProperties.detail.title'
                },
                views: {
                    'content@main': {
                        templateUrl: 'app/entities/tab-objects/tab-objects-properties.html',
                        controller: 'TabObjectsPropertiesController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    sort: {
                        squash: true
                    },
                    predicates : {}
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams) {
                        return {
                            predicates : $stateParams.predicates
                        }}],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('tabDevicesReleasesProperties');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'TabObjects', function ($stateParams, TabObjects) {
                        return TabObjects.get({id: $stateParams.id});
                    }],
                    properties: ['$stateParams', 'TabObjectProperties', function ($stateParams, TabObjectProperties) {
                        return TabObjectProperties.query({id: $stateParams.id, sort: $stateParams.sort});
                    }]
                }
            })
            .state('tab-objects-elastic-properties', {
                parent: 'entity',
                url: '/{id}/tab-object-elastic-properties/',
                data: {
                    authorities: ['ROLE_TECH'],
                    pageTitle: 'jotApp.tabDevicesReleasesProperties.detail.title'
                },
                views: {
                    'content@main': {
                        templateUrl: 'app/entities/tab-objects/tab-objects-elastic-properties.html',
                        controller: 'TabObjectsElasticPropertiesController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('tabDevicesReleasesProperties');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'TabObjects', function ($stateParams, TabObjects) {
                        return TabObjects.get({id: $stateParams.id});
                    }],
                    properties: ['$stateParams', 'TabObjectProperties', function ($stateParams, TabObjectProperties) {
                        return TabObjectProperties.elastic({id: $stateParams.id});
                    }]
                }
            })
            .state('tab-objects-properties-history', {
                parent: 'entity',
                url: '/{id}/tab-object-properties-history/{property}',
                data: {
                    authorities: ['ROLE_DOMAIN_USER'],
                    pageTitle: 'jotApp.tabDevicesReleasesProperties.detail.title'
                },
                views: {
                    'content@main': {
                        templateUrl: 'app/entities/tab-objects/tab-objects-properties-history.html',
                        controller: 'TabObjectsPropertiesHistoryController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('tabDevicesReleasesProperties');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'TabObjects', function ($stateParams, TabObjects) {
                        return TabObjects.get({id: $stateParams.id});
                    }],
                    property: ['$stateParams', 'TabObjectProperties', function ($stateParams, TabObjectProperties) {
                        return TabObjectProperties.queryById({id:$stateParams.property});
                    }]
                }
            })
            .state('tab-objects-manage-domain', {
                parent: 'tab-objects',
                url: '/{id}/manage-domain',
                data: {
                    authorities: ['ROLE_ADMIN']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/tab-objects/tab-objects-manage-domain.html',
                        controller: 'TabObjectsManageDomainController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['TabObjects', function (TabObjects) {
                                return TabObjects.get({id: $stateParams.id});
                            }]
                        }
                    }).result.then(function () {
                        $state.go('tab-objects', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('tab-objects.rerunning', {
                parent: 'tab-objects',
                url: '/{id}/rerunning',
                data: {
                    authorities: ['ROLE_DOMAIN_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/tab-objects/tab-objects-rerunning-dialog.html',
                        controller: 'TabObjectsRerunningController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['TabObjects', function (TabObjects) {
                                return TabObjects.get({id: $stateParams.id});
                            }]
                        }
                    }).result.then(function () {
                        $state.go('tab-objects', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('tab-objects-view-last-data', {
                parent: 'tab-objects',
                url: '/view-last-data/{id}&{name}',
                data: {
                    authorities: ['ROLE_TECH'],
                    pageTitle: 'jotApp.tabObjects.detail.title'
                },
                views: {
                    'content@main': {
                        templateUrl: 'app/entities/tab-objects/tab-objects-view-last-data.html',
                        controller: 'TabObjectViewLastDataController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    uniqueCode: ['$stateParams', function ($stateParams) {
                        return $stateParams.name;
                    }],
                    entity: ['$stateParams', 'TabObjects', function ($stateParams, TabObjects) {
                        return TabObjects.viewLastData({id: $stateParams.id});
                    }]
                }
            });
    }

})();
